//import assets
import { useDispatch, useSelector } from "react-redux";
import Pic1 from "../../Assets/images/Rectangle 17120.png";
import { useEffect } from "react";
import { getAllCategoriesStatistics } from "../../store/categoriesStatistics";
import { all } from "axios";
import { useState } from "react";

export const ServiceFolder = ({
  active,
  link,
  setShowAll,
  categories,
  showAll,
  setIdService,
}) => {
  const [countSlice, setCountSlice] = useState(2);
  if (showAll === true) {
    setCountSlice(Infinity);
  }
  const handelClickId = (id) => {
    setIdService(id);
    if (active === false) {
      setShowAll(false);
    }
  };
  return (
    <div className="service-folder">
      {link && (
        
        <div className="service-folder__overlay">
          <p className="service-folder__overlay-num">{categories.length}+</p>
          <p
            className="service-folder__overlay-link"
            onClick={() => setShowAll(true)}
          >
            لمشاهدة المزيد
          </p>
        </div>
      )}

      {categories
        .map((item) => {
          return (
            <div
              className="service-folder__content"
              onClick={() => handelClickId(item.id)}
              key={item.id}
            >
              <Folder active={active} />
              <div
                className="service-folder__galary"
                onClick={() => setShowAll(false)}
              >
                <img
                  src={Pic1}
                  alt="gray folder"
                  className="service-folder__galary-img"
                />
                <img
                  src={Pic1}
                  alt="gray folder"
                  className="service-folder__galary-img"
                />
                <img
                  src={Pic1}
                  alt="gray folder"
                  className="service-folder__galary-img"
                />
              </div>
              <div
                className=" service-folder__info"
                style={active ? { color: "#fff" } : {}}
              >
                <p>{item.name_ar}</p>
                <div>
                  <p> {item.orders_numbers} طلب </p>
                  <p> {item.orders_amounts} د.ك </p>
                </div>
              </div>
            </div>
          );
        })
        .slice(0, countSlice)}
    </div>
  );
};

const Folder = ({ active }) => {
  return (
    <div>
      <svg
        width="346"
        height="303"
        viewBox="0 0 346 303"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="service-folder__img"
      >
        <g filter="url(#filter0_d_1308_9609)">
          <path
            d="M30.4 32H190.486L218.993 4.68801C220.542 3.20004 222.382 2.0199 224.408 1.21539C226.435 0.410872 228.607 -0.00216225 230.8 8.51227e-06H297.6C316.02 8.51227e-06 331 14.352 331 32V256C331 273.648 316.02 288 297.6 288H30.4C11.9799 288 -3 273.648 -3 256V64C-3 46.352 11.9799 32 30.4 32Z"
            fill={!active ? "#E0E0E0" : "#FF8900"}
          />
        </g>
        <defs>
          <filter
            id="filter0_d_1308_9609"
            x="-8"
            y="-5"
            width="354"
            height="308"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="5" dy="5" />
            <feGaussianBlur stdDeviation="5" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_1308_9609"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_1308_9609"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    </div>
  );
};
